import React, { useEffect, useMemo, useState } from "react";
import MeetingContainer from "../../meetingContainer/MeetingContainer";
import { MeetingProvider } from "@videosdk.live/react-sdk";
import { MeetingAppProvider } from "../../MeetingAppContextDef";
import JoinMeeting from "../../components/JoinScreen";
import ClickAnywhereToContinue from "../../components/ClickAnywhereToContinue";
import { Box, CircularProgress } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import ErrorPage from "../../components/ErrorPage";
import { Detector } from "react-detect-offline";

import jwt_decode from "jwt-decode";

import CreateMeeting from "../../createMeeting";
import { useSearchParams } from "react-router-dom";

const Meeting = () => {
  let [searchParams, setSearchParams] = useSearchParams();

  const [userHasInteracted, setUserHasInteracted] = useState(
    searchParams.get("interacted") ? searchParams.get("interacted") : null
  );
  const [meetingId, setMeetingid] = useState(searchParams.get("id"));

  const [meetingToken, setMeetingToken] = useState(
    localStorage.getItem("meetingToken")
      ? localStorage.getItem("meetingToken")
      : ""
  );
  let permission 
  if(meetingToken){
    var decodedHeader = jwt_decode(meetingToken);
    permission=decodedHeader
  }
  
  const [meetingIdValidation, setMeetingIdValidation] = useState({
    isLoading: true,
    meetingId: searchParams.get("id"),
    reqError: null,
    reqStatusCode: null,
  });

  const [name, setName] = useState(
    searchParams.get("interacted") ? searchParams.get("interacted") : ""
  );
  const [joinScreenWebCam, setJoinScreenWebCam] = useState(true);

  const [joinScreenMic, setJoinScreenMic] = useState(true);
  const [selectedMic, setSelectedMic] = useState({ id: null });
  const [selectedWebcam, setSelectedWebcam] = useState({ id: null });

  const validateMeetingId = async ({ meetingId, token }) => {
    const BASE_URL = "https://api.zujonow.com";

    const urlMeetingId = `${BASE_URL}/v1/prebuilt/meetings/${meetingId}`;

    const resMeetingId = await fetch(urlMeetingId, {
      method: "POST",
      headers: { "Content-type": "application/json", Authorization: token },
    });

    const meetingIdJson = await resMeetingId.json();

    const validatedMeetingId = meetingIdJson.meetingId;

    if (validatedMeetingId) {
      setMeetingIdValidation({
        isLoading: false,
        meetingId: validatedMeetingId,
        reqError: null,
        reqStatusCode: null,
      });
    } else {
      setMeetingIdValidation({
        isLoading: false,
        meetingId: null,
        reqError: meetingIdJson.error,
        reqStatusCode: meetingIdJson.statusCode,
      });
    }
  };

  useEffect(() => {
    validateMeetingId({
      meetingId: meetingId,
      token: meetingToken,
    });
  }, [meetingId, meetingToken]);

  useEffect(async () => {
    if (meetingToken === "") {
      await fetch("https://nowevents.herokuapp.com/temp-join-token", {
        method: "GET",
      })
        .then((r) => r.json())
        .then((response) => {
          setMeetingToken(response?.token);
        });
    }
  }, []);

  const theme = useTheme();
  // : meetingIdValidation.reqError ? (
  //   <ErrorPage
  //     errMsg={meetingIdValidation.reqError}
  //     statusCode={meetingIdValidation.reqStatusCode}
  //   />
  // )
  return meetingIdValidation.isLoading ? (
    <Box
      style={{
        display: "flex",
        flex: 1,
        flexDirection: "column",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.background.default,
      }}
    >
      <CircularProgress size={"4rem"} />
    </Box>
  ) : userHasInteracted && meetingIdValidation.meetingId ? (
    <Detector
      render={({ online }) =>
        online ? (
          <MeetingAppProvider
            {...{
              redirectOnLeave: "https://nowevents.vercel.app",
              chatEnabled: true,
              screenShareEnabled: true,
              pollEnabled: false,
              whiteboardEnabled: true,
              participantCanToggleSelfWebcam: true,
              participantCanToggleSelfMic: true,
              raiseHandEnabled: true,
              recordingEnabled: false,
              recordingWebhookUrl: null,
              autoStartRecording: false,
              participantCanToggleRecording: false,
              brandingEnabled: false,
              poweredBy: false,
              liveStreamEnabled: true,
              autoStartLiveStream: true,
              liveStreamOutputs: null,
              brandLogoURL: null,
              brandName: null,
              participantCanLeave: true,
              askJoin: true,
              participantCanToggleOtherMic: true,
              participantCanToggleOtherWebcam: true,
              notificationSoundEnabled: false,
              // layout: paramKeys.layout,
              canPin: true,
              selectedMic,
              selectedWebcam,
              joinScreenWebCam,
              joinScreenMic,
              canRemoveOtherParticipant: true,
              canEndMeeting: permission?.permissions?.includes("allow_join"),
              canDrawOnWhiteboard: true,
              canToggleWhiteboard: true,
              whiteboardEnabled: true,
            }}
          >
            <MeetingProvider
              config={{
                meetingId: meetingIdValidation.meetingId,
                micEnabled: joinScreenMic,
                webcamEnabled: joinScreenWebCam,
                name: name,
                maxResolution: "hd",
              }}
              token={meetingToken}
              joinWithoutUserInteraction
            >
              <MeetingContainer />
            </MeetingProvider>
          </MeetingAppProvider>
        ) : (
      <ErrorPage  errMsg={"Your internet seems unstable, please check it & refresh the page once"} statusCode={403} />
        )
      }
    />
  ) : true ? (
    <JoinMeeting
      onClick={({ name, webcamOn, micOn }) => {
        setName(name);
        setJoinScreenMic(micOn);
        setJoinScreenWebCam(webcamOn);
        setUserHasInteracted(true);
      }}
      {...{
        micEnabled: true,
        webcamEnabled: true,
      }}
      name={name}
      setName={setName}
      setSelectedMic={setSelectedMic}
      setSelectedWebcam={setSelectedWebcam}
      meetingUrl={window.location.href}
      meetingTitle={"meeting"}
      participantCanToggleSelfWebcam={"true"}
      participantCanToggleSelfMic={"true"}
    />
  ) : (
    <ClickAnywhereToContinue
      onClick={() => {
        setUserHasInteracted(true);
      }}
      title="Click anywhere to continue"
    />
  );
};

export default Meeting;
